module.exports = __webpack_public_path__ + "img/img4.66d15c28.png";